import { useCallback, useState } from "react";
import { Flags } from "@/feature-flags";
import { useFlag } from "@/hooks/use-flag";

export type FollowModeState = {
    enabled: boolean;
    toggle: () => void;
    setEnabled: (enabled: boolean) => void;
};

export const useFollowMode = (): FollowModeState | undefined => {
    const { value: isAgentFollowModeEnabled, loading: isAgentFollowModeLoading } = useFlag(
        Flags.EnableAgentFollowMode,
        false,
    );
    const [enabled, setEnabled] = useState(false);

    const toggle = useCallback(() => {
        setEnabled((prev) => !prev);
    }, []);

    // Return undefined if feature flag is still loading
    if (isAgentFollowModeLoading) {
        return undefined;
    }

    // Return undefined if feature flag is disabled
    if (!isAgentFollowModeEnabled) {
        return undefined;
    }

    return {
        enabled,
        toggle,
        setEnabled,
    };
};
